import { render, staticRenderFns } from "./ClaimView.vue?vue&type=template&id=17f613d8&scoped=true"
import script from "./ClaimView.vue?vue&type=script&lang=js"
export * from "./ClaimView.vue?vue&type=script&lang=js"
import style0 from "./ClaimView.vue?vue&type=style&index=0&id=17f613d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f613d8",
  null
  
)

export default component.exports